import React from "react";
//import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// import Test from "./Components/Test";
// import About from "./Components/About";
import Login from "./Login";
import Register from "./Register";
import CategoryPreference1 from "./Preference/categoryPreference1.js";
import CategoryPreference2 from "./Preference/categoryPreference2.js";
import ProductGrid from "./Dashboard/Recommendationmain.js";
import ProductGridW from "./Dashboard/RecommendWatchmain.js";
import ProductGridC from "./Dashboard/RecommendClothingmain.js";
import ProductGridG from "./Dashboard/RecommendGamingMain.js";
import ProductGridB from "./Dashboard/RecommendBooksmain.js";
import ProductDetails from "./Dashboard/ProductDetails.js";
import ProductDetailsa from "./Dashboard/ProductDetailsapi.js";
import UserProfile from "./Dashboard/UserProfilePage.js";
import Dashboard from "./Dashboard/Dashboard.js";
import SummaryComponent from "./Dashboard/Summarycountmain.js";
// import UploadImage from "./Components/Dashboard/UploadImage.js";
// import Retrieve from "./Components/Dashboard/RetrieveImage.js";
// import Retrievetest from "./Components/Dashboard/retrieveImagecategory.js";
// import Sidebar from "./Components/Dashboard/Sidebar.js";

// import EventPreference from "./Components/Preference/EventPreference.js";
// import UserProfile from "./Components/Dashboard/UserProfilePage.js";
// import MovieRecommendations from "./Components/Dashboard/movierecompage.js";
// import AddImage from "./Components/Dashboard/AddImagePage.js";
// import EventBook from "./Components/Dashboard/EventBookingPage.js";
// import SummaryPage from "./Components/Dashboard/SummaryPage.js";
// import Dashboard from "./Components/Dashboard/Dashboard";
// import DemographicPage from "./Components/Dashboard/DemographicPage.js";
// import AppointmentSchedulingPage from "./Components/Dashboard/AppointmentSchedulingPage.js";
// import SummaryPage from "./Components/Dashboard/SummaryPage.js";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* <Route path="/" element={<Test />} />
          <Route path="/about" element={<About />} /> */}
          <Route path="/" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/categorypreference1" element={<CategoryPreference1/>} />
          <Route path="/categorypreference2" element={<CategoryPreference2/>} />
          <Route path="/recommendation" element={<ProductGrid/>} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/watchrecommendation" element={<ProductGridW />} />
          <Route path="/clothingrecommendation" element={<ProductGridC />} />
          <Route path="/gamingrecommendation" element={<ProductGridG />} />
          <Route path="/booksrecommendation" element={<ProductGridB />} />
          <Route path="/product/:productId/:category" element={<ProductDetails />} />
          <Route path="/producta/:category/:price/:title/:image/:slink" element={<ProductDetailsa />} />
          <Route path="/userprofile" element={<UserProfile/>} />
          <Route path="/summarydetails" element={<SummaryComponent/>} />
          {/* <Route path="/upload" element={<UploadImage/>} />
          <Route path="/retrieve" element={<Retrieve/>} />
          <Route path="/sidebar" element={<Sidebar/>} />

          <Route path="/retrievetest" element={<Retrievetest/>} />
          <Route path="/eventpreference" element={<EventPreference/>} />

          <Route path="/movierecommendations" element={<MovieRecommendations/>} />
          <Route path="/addimage" element={<AddImage/>} />
          <Route path="/eventbooking" element={<EventBook/>} />
          <Route path="/summarydetails" element={<SummaryPage/>} /> */}
          {/* <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/demographicdetails" element={<DemographicPage />} />
          <Route path="/appointmentscheduling" element={<AppointmentSchedulingPage />} />
          <Route path="/summarydetails" element={<SummaryPage />} /> */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
